// extracted by mini-css-extract-plugin
module.exports = {"paypalSymbolImg":"cn_paypalSymbolImg__IMxoY","mhcTtext":"cn_mhcTtext__36f1H","fontItaly":"cn_fontItaly__3fotY","iconDiv":"cn_iconDiv__1o57U"};